<!-- @mouseenter="checkHasOwnThisImgFun" -->
<template>
  <div class="div_class" style=" " >
    <div class="btns_class">
      <el-button style="display: none;"
        title="返回"
        type="primary"
        @click="jump2Back"
        icon="el-icon-top-left"
        circle
      ></el-button>

      <div class="bn">
        <!-- 根据 ownThisImg 状态显示不同的按钮 -->
        <img v-if="!ownThisImg" @click="addFavorite"  src="static/images/favorite.png" title="加入收藏1"/>
        <img v-else @click="delFavorite"  src="static/images/favorite_ok.png" title="移出收藏"/>
      </div>

      <div class="bn" style="display: none;">
        <img @click="openYuanTu"  src="static/images/yt.png" title="原图"/>
      </div>

      <div class="bn">
        <el-tooltip
            class="item"
            effect="dark"
            :content="ownThisImg?'已收藏': '请先加入收藏,再进行标注'"
            placement="top"
          >
            <img @click="addNote"  src="static/images/mark.png" title="点击图片，在指定位置加标注"/>
          </el-tooltip>
      </div>

      <div class="bn">
        <img @click="downImage"  src="static/images/down.png" title="下载"/>
      </div>

      <div class="bn" style="position: relative;">
         <div style="height: 10px; width: 10px; z-index: 1; position: absolute; left: 5px; top: 5px; overflow: hidden; padding-top: 30px;" >
          <input type="text" id="shareLink" readonly><!-- 如果隐藏就不会复制成功 -->
        </div>
        <div style="width: 100%; height: 100%; z-index: 10; ">
            <img @click="generateShareLink"  src="static/images/share.png" title="分享"/>
        </div>
      </div>

      <!---
      <el-button
        title="下载"
        type="primary"
        @click="downImage"
        icon="el-icon-download"
        circle
      ></el-button>
      <el-button
        title="加入收藏"
        type="primary"
        @click="addFavorite"
        :icon="collectionIconStyle"
        circle
      ></el-button>
      <el-button style=" display: none;"
        title="背景切换"
        type="primary"
        icon="el-icon-copy-document"
        circle
        @click="changeBackgroundFun"
      ></el-button>

      -->

    </div>
  </div>
</template>

<script>

export default {
  emits: ['goBackEvent', 'downloadEvent', 'changeBgEvent'],
  props: {
    imgId: String,
    nowImgInfo: String,
    changeCollectionIconState: Boolean
  },
  data () {
    return {
      collectionIconStyle: 'el-icon-star-off',
      ownThisImg: false,
      cId: 0 // 收藏记录Id 值   用来删除此条收藏用
    }
  },
  methods: {
    openYuanTu () {
      this.$alert('暂不提供', '提示')
    },
    checkHasOwnThisImgFun () { //  加载万立马查看是否有 把该图片加入收藏夹
      this.cId = 0 // 初始化
      const isLogin = this.$store.state.globalObj.nowUserLoginState
      // 如果已经登录 则检查是否已经收藏  否则就不检查不然没意义
      if (isLogin) {
        // 只要鼠标移动到控制按钮div里面就判断是否已收藏当前图片
        this.axios.post('/md/front/additional/collection/check2', this.$stringify({ imgId: this.imgId })).then(res => {
          if (res.status === 200) {
            // eslint-disable-next-line no-debugger
            debugger
            if (res.data !== 0) {
              this.ownThisImg = true
              this.cId = res.data
              // this.$alert('已经收藏')
            } else {
              this.ownThisImg = false
              // this.$alert('还未收藏')
            }
          }
        })
      }
    },
    addNote () {
      const isLogin = this.$store.state.globalObj.nowUserLoginState
      // 如果已经登录 则检查是否已经收藏  否则就不检查不然没意义
      if (isLogin) {
        if (this.ownThisImg) {
          // this.$alert('确定标注？')
          this.$emit('addFlag')
        } else {
          this.$alert('请先将此图加入收藏')
        }
      } else {
        this.$alert('请先登录')
      }
    },
    async generateShareLink () { // 生成分享链接
      const imageElement = document.getElementById('bimg')
      const shareLinkElement = document.getElementById('shareLink')

      // 1. 获取图片原始URL
      const originalImageUrl = imageElement.src

      // 2. 生成唯一标识（这里用时间戳模拟，实际可用图片ID）
      const iName = document.getElementById('imgNameBox').innerHTML
      const imageId = iName

      // eslint-disable-next-line no-debugger
      debugger

      // 1. 获取当前页面的协议、域名和端口
      const { protocol, hostname, port } = window.location

      // 2. 构建基础 URL（处理端口号，避免重复 ":80" 或 ":443"）
      const baseUrl = port ? `${protocol}//${hostname}:${port}` : `${protocol}//${hostname}`

      // 3. 构建分享链接（指向 share.html）
      const sharePageUrl = `${baseUrl}/share.html`

      // 3. 构建分享链接（指向一个专门展示图片的页面）
      // const sharePageUrl = 'http://192.168.0.88:8080/share.html'

      const shareUrl = `${sharePageUrl}?imageId=${imageId}&imageUrl=${encodeURIComponent(originalImageUrl)}`

      // 4. 显示链接并自动选中
      shareLinkElement.value = shareUrl
      shareLinkElement.style.display = 'block'
      shareLinkElement.select()

      // 5. 复制到剪贴板
      if (navigator.clipboard) {
        navigator.clipboard.writeText(shareUrl).then(() => {
          this.$alert('分享链接已复制！')
        })
        return
      }

      // 方案1：尝试现代API
      if (navigator.clipboard?.writeText) {
        try {
          await navigator.clipboard.writeText(shareUrl)
          this.$alert('链接已复制！')
          return
        } catch (err) {
          console.warn('Clipboard API failed:', err)
        }
      }
      shareLinkElement.select()
      // 方案2：降级方案
      try {
        if (document.execCommand('copy')) {
          this.$alert('链接已复制！')
        } else {
          throw new Error('execCommand failed')
        }
      } catch (err) {
        // 方案3：终极降级
        prompt('请手动复制链接：', shareUrl)
      }
      shareLinkElement.blur()
    },
    jump2Back () {
      const fromFavOrHis = this.$route.query.showImage
      if (fromFavOrHis) {
        // 进入这里代表从我的收藏或历史记录过来的, 返回按钮就要返回到那里去
        const fromRoutePath = decodeURIComponent(this.$route.query.fromRoutePath)
        this.$router.push(fromRoutePath).catch(() => {})
        return
      }
      this.$emit('goBackEvent')
    },
    downImage () {
      const isLogin = this.$store.state.globalObj.nowUserLoginState
      // 如果已经登录 则检查是否已经收藏  否则就不检查不然没意义
      if (isLogin) {
        this.$emit('downloadEvent')
      } else {
        this.$alert('您还未登录')
      }
    },
    addFavorite () {
      const tempImgInfo = this.nowImgInfo
      const api = '/md/front/additional/collection/add'
      const params = {
        imgId: this.imgId,
        imgInfo: tempImgInfo
      }
      const that = this
      this.axios.post(api, this.$stringify(params)).then(res => {
        if (res.status === 200) {
          that.ownThisImg = true
          that.cId = res.data

          // 添加成功
          that.$alert('收藏成功', '提示')
          that.collectionIconStyle = 'el-icon-star-on'
        }
      })
    },
    delFavorite () {
      // eslint-disable-next-line no-debugger
      debugger
      const api = '/md/front/additional/collection/del'
      const params = {
        cid: this.cId
      }
      const that = this
      this.axios.post(api, this.$stringify(params)).then(res => {
        if (res.status === 200) {
          // 删除成功
          this.$alert('删除成功', '提示')
          that.ownThisImg = false
        }
      })
    },
    changeBackgroundFun () {
      this.$emit('changeBgEvent')
    }
  },
  watch: {
    changeCollectionIconState () {
      this.collectionIconStyle = 'el-icon-star-off'
    }
  }
}
</script>

<style scoped lang='less'>
.div_class {
  height: 150px;
  width: 100%;
  display: flex;
  flex-direction: column;
  justify-content: center;
  .btns_class{
    height:40px;
    text-align: right;
    margin-right: 2.5rem;
  }
}

.bn{
    display: inline-block;
    width: 40px;
    height: 40px;
    margin-left: 10px;
}

.bn img{
    width: 100%;
    height: 100%;
    cursor: pointer;
}
</style>
